import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Select from 'react-select';
import {config} from "../../../../../../config";
import axios from "axios/index";
import {loadImages, resetImages} from "../../../../../../api/images";
import {getTopics } from "../../../../../../api/topics";


class PromotionGeneralSquareComponent extends Component {
	constructor(props) {
		super(props);


		// this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.handleTopicChange = this.handleTopicChange.bind( this );
		this.handleState = this.handleState.bind(this);
	}

	componentDidMount() {
		resetImages().then( () => {
			loadImages([
				{
					width: 336,
					height: 280,
				}
			]);
		});

		getTopics();
	}

	setSearchQuery(value) {
		api.promotions.handleState('postIds', value);
	}

	getPosts(input, callback) {
		let cancel;

		if ( input.length < 4 ) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input, )
			.then( ( response ) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID: item.ID,
								post_title: item.post_title
							};

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	handleState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handleState( name, value );
	}

	renderTopics() {
		const { topics } = this.props;

		topics.data.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

		return topics.data.map( ( topic, index ) =>
			<MenuItem key={index} value={topic.key} primaryText={topic.name} />
		)

		// console.log( topics );
	}

	handleTopicChange(event, index, value) {
		api.promotions.handleState( 'topicIds', value);
	}

	handleSelectFieldChange(name, event, index, value) {
		api.promotions.handleState( name, value );
	}

	render() {

		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-6 cell">
					<label>
						Koppelen aan posts
						<Select.Async
							multi={true}
							valueKey="ID"
							labelKey="post_title"
							loadOptions={this.getPosts}
							value={this.props.promotion.postIds}
							onChange={this.setSearchQuery}
						/>
					</label>
				</div>
				<div className="medium-6 cell">
					<label>
						Koppelen aan topics
						<SelectField
							floatingLabelText="Topics"
							value={this.props.promotion.topicIds}
							fullWidth={true}
							onChange={this.handleTopicChange}
							multiple={true}
						>
							{this.renderTopics()}
						</SelectField>
					</label>
				</div>

				<div className="medium-6 cell">
					<label>
						Prioriteit
					<SelectField
						value={this.props.promotion.priority}
						onChange={this.handleSelectFieldChange.bind(null, 'priority')}
						name="priority"
						fullWidth={true}
					>
						<MenuItem value={'slow'} primaryText={'Langzaam'} />
						<MenuItem value={'default'} primaryText={'Normaal'} />
						<MenuItem value={'fast'} primaryText={'Snel'} />
					</SelectField>
					</label>
				</div>
				<div className="medium-6 cell">
					<label>
						Max. Aantal weergaven (0 is onbeperkt)
					<TextField
						value={this.props.promotion.maxViews}
						onChange={this.handleState}
						name="maxViews"
						fullWidth={true}
					/>
					</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion,
		topics: state.topics
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	getTopics
})(PromotionGeneralSquareComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/square.js